module.exports = __webpack_public_path__ + "07d273459cfd3a661b07ab29de38a856.MP3";